import { useMemo, useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { useApartmentUnderCoordinator } from '../../assets/api/useCoordinatorApi'
import CoordinatorApartmentListTable from './CoordinatorApartmentListTable'
import AdminToolbar from '../admin/components/AdminToolbar'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { useDialog } from '../../shared/hook/useDialog'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Button, Grid2 } from '@mui/material'
import { Constants, Grid_Gap } from '../../shared/constants'
import { LocationFilterFields } from '../../shared/components/LocationFilterFields'

const CoordinatorApartmentList = () => {
    const [filters, setFilters] = useState({})
    const [searchQuery, setSearchQuery] = useState('');
    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: ApartmentList, isLoading } = useApartmentUnderCoordinator(filters)
    const handleSearchChange = (value) => {
        setSearchQuery(value);
    };
    const originalRow = useMemo(() => {
        return ApartmentList?.apartments?.map((item, index) => ({
            id: index + 1,
            sr_no: index + 1,
            ...item
        })) || [];
    }, [ApartmentList]);
    const filteredRows = useMemo(() => {
        if (!searchQuery.trim()) {
            return originalRow;
        }
        const lowercasedQuery = searchQuery.toLowerCase();
        return originalRow.filter(student =>
            Object.values(student).some(val =>
                val != null && val.toString().toLowerCase().includes(lowercasedQuery)
            )
        );
    }, [originalRow, searchQuery]);


    const validationSchema = Yup.object().shape({

    });
    const handleSubmit = (values, { resetForm }) => {
        const filteredValues = Object.fromEntries(
            Object.entries(values).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );
        setFilters(filteredValues);
        handleClose();
    };
    return (
        <>

            <NormalContainerWithHeader headerText={"Apartment List"}
                RightContent={
                    <AdminToolbar
                        onSearchChange={handleSearchChange}
                        onFilterClick={handleClickOpen}
                        filterIcon={Constants.customImages.FilterDark}

                    />
                }
            >
                <CoordinatorApartmentListTable apartmentRows={filteredRows} isLoading={isLoading} />
            </NormalContainerWithHeader>
            <MainDialogBox open={open} handleClose={handleClose} width={"40%"}>
                <Formik initialValues={setFilters} enableReinitialize={true} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <LocationFilterFields
                                    countryField="country_id"
                                    stateField="state_id"
                                    cityField="city_id"
                                    zoneField="zone_id"
                                    clusterField="cluster_id"
                                    isStoredId={true}
                                />
                                <Grid2 children textAlign={"end"} size={12}>
                                    <Button variant='contained' type='submit' fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </>
    )
}

export default CoordinatorApartmentList